/**
 * @author Vladislavs Zimnikovs <vladislavs.zimnikovs@scandiweb.com>
 * @license OSL-3.0 (Open Software License ("OSL") v. 3.0)
 * @package puma-mx
 */

export const SIZE_CHART_POPUP_ID = 'SizeChartPopup';
// PumaPWA UAE only - Size chart block ID's for EN store
export const KIDS_FOOTWEAR_BLOCK_UAE_EN = 'size-chart-kids-footwear-uae-en';
export const WOMENS_FOOTWEAR_BLOCK_UAE_EN = 'size-chart-womens-footwear-uae-en';
export const MENS_FOOTWEAR_BLOCK_UAE_EN = 'size-chart-mens-footwear-uae-en';
export const KIDS_CLOTHES_BLOCK_UAE_EN = 'size-chart-kids-clothes-uae-en';
export const WOMENS_CLOTHES_BLOCK_UAE_EN = 'size-chart-womens-clothes-uae-en';
export const MENS_CLOTHES_BLOCK_UAE_EN = 'size-chart-mens-clothes-uae-en';
// PumaPWA UAE only - Size chart block ID's for AR store
export const KIDS_FOOTWEAR_BLOCK_AR = 'size-chart-kids-footwear-uae-ar';
export const WOMENS_FOOTWEAR_BLOCK_AR = 'size-chart-womens-footwear-uae-ar';
export const MENS_FOOTWEAR_BLOCK_AR = 'size-chart-mens-footwear-uae-ar';
export const KIDS_CLOTHES_BLOCK_AR = 'size-chart-kids-clothes-uae-ar';
export const WOMENS_CLOTHES_BLOCK_AR = 'size-chart-womens-clothes-uae-ar';
export const MENS_CLOTHES_BLOCK_AR = 'size-chart-mens-clothes-uae-ar';
export const KIDS_LABELS = ['Boys', 'Girls', 'الأولاد', 'البنات'];
export const MEN_LABELS = ['Men', 'Male', 'الرجال'];
export const WOMEN_LABELS = ['Women', 'Female', 'النساء'];
export const UNISEX_LABELS = ['Unisex', 'للجميع'];
export const APPAREL_LABELS = ['Apparel', 'الملابس'];
export const FOOTWEAR_LABELS = ['Footwear', 'الأحذية'];
export const ACCESSORIES_LABELS = ['Accessories', 'الإكسسورات'];
